<div class="sale-dead-line-popup">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-basic-title">
      Deadlines - {{ sale.saleName }}
    </h6>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <div
      class="table-responsive data-grid sticky-header-table sticky-header-table-height-lg"
      #table
    >
      <div class="data-grid">
        <div class="table table-commence-days">
          <!-- Header Row -->
          <div class="row border-bottom">
            <div
              class="col-md-12 text-warning font-bold"
              *ngIf="sale.isBreezeUpSale"
            >
              Radiographs and Scope Videos must not be submitted prior to Breeze
              Date
            </div>
          </div>
          <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-9">
              <div class="row">
                <div
                  [class.col-md-4]="sale.isBreezeUpSale"
                  [class.col-md-2]="!sale.isBreezeUpSale"
                ></div>
                <div class="col-md-4 font-bold text-center">X-RAYS</div>
                <div class="col-md-4 font-bold text-center">SCOPE VIDEO</div>
              </div>
            </div>
          </div>
          <div class="row mat-header-row h-auto">
            <div class="col-12 col-md-3 text-center">
              <label class="t-heading">Sale Date/Time</label>
            </div>
            <div class="col-12 col-md-9">
              <div class="row">
                <div class="col-md-2 text-center">
                  <label class="t-heading">Hips</label>
                </div>
                <div class="col-md-2 text-center" *ngIf="sale.isBreezeUpSale">
                  <label class="t-heading text-warning">Breeze</label>
                </div>
                <div class="col-md-2 text-center">
                  <label class="t-heading">Submitted</label>
                </div>
                <div class="col-md-2 text-center">
                  <label class="t-heading">Viewing</label>
                </div>
                <div class="col-md-2 text-center">
                  <label class="t-heading">Submitted</label>
                </div>
                <div class="col-md-2 text-center">
                  <label class="t-heading">Viewing</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Data Rows -->
          <ng-container>
            <div
              *ngFor="let element of datasource; let index"
              class="row mat-row border-0 h-auto"
              [ngClass]="{
                'border-bottom': index < datasource.length - 1
              }"
            >
              <div
                class="col-12 col-md-3 border-bottom border-left border-right flex align-items-center justify-center"
                [class.border-top]="index === 0"
              >
                <div class="t-data">
                  <div class="box">
                    <div class="font-15 text-center">
                      Book {{ element.bookNumber }} Session
                      {{ element.sessionNumber }}
                    </div>
                    <div class="font-15 font-bold text-center">
                      {{ element.minLotNumber }} -
                      {{ element.maxLotNumber }}
                    </div>
                    <div class="text-center">
                      {{ 
                        element.startDate
                          ? (element.startDate | date : "dd MMM yyyy") + " " +
                            (showTimePart(element.startDate))
                          : ""
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div
                  class="row p-0 border-bottom border-right"
                  [class.h-100]="element.breezeups.length === 1"
                  *ngFor="let item of element.breezeups"
                >
                  <div
                    class="col-12 col-md-2 p-3 border-right flex align-items-center justify-center"
                  >
                    <div class="t-data">
                      <div class="box">
                        <ng-container
                          *ngIf="sale.isBreezeUpSale; else sessionLot"
                        >
                          {{ item.breezeMinLotNumber }} -
                          {{ item.breezeMaxLotNumber }}
                        </ng-container>
                        <ng-template #sessionLot>
                          {{ element.minLotNumber }} -
                          {{ element.maxLotNumber }}
                        </ng-template>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-2 p-3 border-right flex align-items-center justify-center"
                    *ngIf="sale.isBreezeUpSale"
                  >
                    <div class="t-data">
                      <div class="box text-warning text-center">
                        {{
                          item.breezeDate | date : "EEE, dd MMM YYYY "
                        }}
                        {{ showTimePart(item.breezeDate) }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-2 p-3 border-right flex align-items-center justify-center"
                  >
                    <div class="t-data">
                      <div class="box text-center">
                        {{
                          item.xrayScopeTaken
                            | date : "EEE, dd MMM YYYY "
                        }}
                        {{ showTimePart(item.breezeDate) }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-2 p-3 border-right flex align-items-center justify-center"
                  >
                    <div class="t-data">
                      <div class="box text-center">
                        {{
                          item.xrayScopeVisible
                            | date : "EEE, dd MMM YYYY "
                        }}
                        {{ showTimePart(item.breezeDate) }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-2 p-3 border-right flex align-items-center justify-center"
                  >
                    <div class="t-data">
                      <div class="box text-center">
                        {{
                          item.xrayScopeTaken
                            | date : "EEE, dd MMM YYYY "
                        }}
                        {{ showTimePart(item.breezeDate) }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12 col-md-2 p-3 flex align-items-center justify-center"
                  >
                    <div class="t-data">
                      <div class="box text-center">
                        {{
                          item.xrayScopeVisible
                            | date : "EEE, dd MMM YYYY "
                        }}
                        {{ showTimePart(item.breezeDate) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Loader -->
        </div>
      </div>
    </div>
  </div>
  <!--<div class="modal-footer">
    <div class="button-group">
      <button
        type="button"
        class="btn btn-primary btn-sm me-2"
        (click)="closePopup()"
      >
        Close
      </button>-->
      <!--<button type="button"
                class="btn btn-primary btn-sm"
                (click)="submit()"
                [disabled]="validateSubmitButton()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSubmitLoading"></i>
          <i class="fa fa-save" *ngIf="!isSubmitLoading"></i> Send
        </button>-->
    <!--</div>
  </div>-->
</div>
